import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

import { CoreInputProps } from './CoreInput';

const getLabelColor = (disabled?: CoreInputProps['disabled']) => {
    if (disabled) {
        return theme.colors.foreground.disabled;
    }

    return theme.colors.foreground.default;
};

interface InputLabelTextProps extends Pick<CoreInputProps, 'disabled'> {}

export const InputLabelText = styled.div<InputLabelTextProps>`
    color: ${(props) => getLabelColor(props.disabled)};
    font-size: 14px;
    font-weight: ${theme.fontWeights[500]};
    line-height: 24px;

    transition: color 75ms;
`;
